import React from "react";
import "./logopage.scss";

const LogoPage = () => {
    return (
        <>
            <img
                className="logo_page"
                src="../assets/page/logo_custom-acai.svg"
                alt="Logo do custom acai"
            />
        </>
    );
};

export default LogoPage;
